import { Button, Col, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormTimePicker from "components/form/FormProvide/FormTimePicker";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { CloseOutlined, CloudUploadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";

const SupOtRequestForm = ({
    isOpen = false,
    onClose = () => { },
    onSubmit = () => { },
    selectedDate = "",
    setpreviousFilew = () => { },
    onAttachFileChange = () => { },
    selectedOtTime = "",
    selectedOtTimeEnd = ""
}) => {
    const { t } = useTranslation();
    const [form] = useForm(null);
    const [fileSizeInMB, setfileSizeInMB] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [fileType, setFileType] = useState([]);
    const [initialValuesFileName, setInitialValuesFileName] = useState([]);
    const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
    const [initialValuesFileType, setInitialValuesFileType] = useState([]);
    const [initialValuesFileList, setInitialValuesFileList] = useState([]);

    const onDeleteFile = (index) => {
        setImageUrl((prev) => prev.filter((_, i) => i !== index));
        setFileName((prev) => prev.filter((_, i) => i !== index));
        setfileSizeInMB((prev) => prev.filter((_, i) => i !== index));
        setFileType((prev) => prev.filter((_, i) => i !== index));
        setpreviousFilew(null);
    };

    useEffect(() => {
        if (isOpen && selectedDate) {
            const initialValues = {
                startDate: selectedDate ? dayjs(selectedDate) : null,
                startTime: selectedOtTime ? dayjs(selectedOtTime, "HH:mm:ss") : null,
                endTime: selectedOtTimeEnd ? dayjs(selectedOtTimeEnd, "HH:mm:ss") : null,
            };
            form.setFieldsValue(initialValues);
        }
    }, [isOpen, selectedDate, form, selectedOtTime, selectedOtTimeEnd]);

    return (
        <FormAntd
            form={form}
            onFinish={(values) => {
                onSubmit(values);
                form.resetFields();
                onClose();
            }}
        >
            <FormItem shouldUpdate={(prev, curv) => false}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                            <Col span={24}>
                                <FormDatePicker
                                    name="startDate"
                                    label={t("my_request.label.overtime-date")}
                                    required
                                    size="large"
                                />
                            </Col>
                            <Row justify={"space-between"}>
                                <Col span={11}>
                                    <FormTimePicker
                                        name="startTime"
                                        label={t("leave_type.label.start-time")}
                                        size="large"
                                    />
                                </Col>
                                <Col span={11}>
                                    <FormTimePicker
                                        name="endTime"
                                        label={t("leave_type.label.end-time")}
                                        size="large"
                                    />
                                </Col>
                            </Row>
                            <FormInput
                                type="textarea"
                                name="description"
                                label={t("expense.lable.reason")}
                                placeholder={t("please-enter")}
                                required
                                rows={4}
                            />

                            <>
                                <Dragger
                                    name="attachFile"
                                    multiple={false}
                                    showUploadList={false}
                                    onRemove={() => onDeleteFile()}
                                    onChange={(e) => {
                                        if (e.event) {
                                            onAttachFileChange({
                                                attachFile: e,
                                                setFieldValue,
                                                setImageUrl,
                                                setFileName,
                                                initialValuesImageUrl,
                                                initialValuesFileName,
                                                initialValuesFileType,
                                                initialValuesFileList,
                                                setInitialValuesFileName,
                                                setInitialValuesFileType,
                                                setInitialValuesImageUrl,
                                                setInitialValuesFileList
                                            });
                                        }
                                    }}
                                    style={{
                                        border: "1px solid #EAECF0",
                                        borderRadius: "10px",
                                        background: "#FAFAFA",
                                        padding: "20px",
                                    }}
                                >
                                    <p>
                                        <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                                    </p>
                                    <p
                                        style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                                    >
                                        {t("description.Select the desired file or drag and drop")}
                                    </p>
                                </Dragger>
                                <p>{t('description.Supported files mb')}</p>
                            </>

                            {imageUrl && (
                                <>
                                    {imageUrl?.map((attachFile, index) => (
                                        <>
                                            {index === 0 && (
                                                <Col span={24}>
                                                    <label >
                                                        {t('employee.label.attachment-file')}
                                                    </label>
                                                </Col>
                                            )}

                                            <Row>
                                                <div
                                                    style={{
                                                        border: "2px solid var(--button-color)",
                                                        borderRadius: "10px",
                                                        padding: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        maxWidth: "500px",
                                                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    <a
                                                        href={attachFile}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            textDecoration: "none",
                                                        }}
                                                    >
                                                        <img
                                                            src={attachFile}
                                                            alt="uploaded"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.display = "none";
                                                                const fallbackElement = e.target.nextElementSibling;
                                                                if (fallbackElement) fallbackElement.style.display = "block";
                                                            }}
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                objectFit: "cover",
                                                                borderRadius: "5px",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                                            <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                                        </div>
                                                    </a>
                                                    <Button
                                                        type="default"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            color: "#888",
                                                            cursor: "pointer",
                                                            fontSize: "18px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                        onClick={() => {
                                                            const newImage = imageUrl.filter((_, i) => i !== index);
                                                            const newFileName = fileName.filter((_, i) => i !== index);
                                                            const newFileSize = fileSizeInMB.filter((_, i) => i !== index);
                                                            const newFileType = fileType.filter((_, i) => i !== index);

                                                            setImageUrl(newImage);
                                                            setFileName(newFileName);
                                                            setfileSizeInMB(newFileSize);
                                                            setFileType(newFileType);

                                                            form.setFieldsValue({
                                                                attachFile: newImage,
                                                                attachFileName: newFileName,
                                                                attachFileType: newFileType,
                                                            });
                                                        }}
                                                    >
                                                        <CloseOutlined />
                                                    </Button>
                                                </div >
                                            </Row >
                                        </>
                                    ))}
                                </>
                            )
                            }

                            <Row style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => {
                                        resetFields();
                                        onClose();
                                    }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.save").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default SupOtRequestForm;